import React from 'react';

import { useLanguageContext } from '@techchange/components';

import { RESOURCE_TYPES } from '../../constants';

import EmbedContent from './content/embed';
import FormContent from './content/form';
import ImageContent from './content/image';
import MiroContent from './content/miro';
import PollContent from './content/poll';
import QuizContent from './content/quiz';
import SlideContent from './content/slide';
import VideoContent from './content/video';
import { contentBuilderPropTypes } from './utils/propTypes';

const propTypes = contentBuilderPropTypes.content;

const defaultProps = {
	isAdmin: false,
	isEditing: false,
};

/**
 * Shared component to render the resource content builder.
 *
 * @param {Object} props The props.
 *
 * @returns {Object} The rendered component.
 */
const ResourceContentBuilder = (props) => {

	const { chooseContentFromLanguage } = useLanguageContext();

	// Get the translated content for the resource
	const resourceContent = chooseContentFromLanguage(props.data.resource_contents);

	const childProps = {
		...props,
		resourceContent,
	};

	switch (props.data.type) {
	case RESOURCE_TYPES.EMBED:
		return (
			<EmbedContent {...childProps} />
		);
	case RESOURCE_TYPES.FORM:
		return (
			<FormContent {...childProps} />
		);
	case RESOURCE_TYPES.IMAGE:
		return (
			<ImageContent {...childProps} />
		);
	case RESOURCE_TYPES.MIRO:
		return (
			<MiroContent {...childProps} />
		);
	case RESOURCE_TYPES.POLL:
		return (
			<PollContent {...childProps} />
		);
	case RESOURCE_TYPES.QUIZ:
		return (
			<QuizContent {...childProps} />
		);
	case RESOURCE_TYPES.SLIDE:
		return (
			<SlideContent {...childProps} />
		);
	case RESOURCE_TYPES.VIDEO:
		return (
			<VideoContent {...childProps} />
		);
	default:
		console.warn(`The resource type=${props.data.type} is not supported...`);
		return null;
	}

};

ResourceContentBuilder.propTypes = propTypes;
ResourceContentBuilder.defaultProps = defaultProps;

export default ResourceContentBuilder;
